/* ============================================
   GIOVANI DEMOCRATICI — Configurazione App
   ============================================ */

/**
 * Durata del loading iniziale in millisecondi.
 * Modificare questo valore per cambiare il tempo di permanenza del loader.
 */
export const LOADING_DURATION = 3000;

/**
 * URL del logo dei Giovani Democratici.
 * Sostituire questo valore per cambiare il logo in tutto il sito.
 */
export const LOGO_URL =
  'https://upload.wikimedia.org/wikipedia/it/7/7c/Giovani_Democratici.svg';

/**
 * Alt text per il logo.
 */
export const LOGO_ALT = 'Giovani Democratici';

/**
 * Link al sito del Partito Democratico.
 */
export const PD_URL = 'https://partitodemocratico.it';
